export default "__VITE_ASSET__4b38c39d__"